<template>
    <div style="width: 220px;height: 90px;border: 1px solid #AAACAE;padding: 15px;display: flex;box-sizing: border-box">
        <div style="width: 40px;height: 60px;display: flex;align-items:center">
            <img :src="require('../../../assets/images/user.png')" alt="" width="27" height="29">
        </div>
        <div style="width: 100%;height: 60px;padding-left: 10px">
            <el-row style="height: auto">
                <el-col :span="18" style="font-size:20px;color: black;padding-top:5px">{{userName}}</el-col>
                <el-col :span="6" style="text-align: right">
                    <el-button type="text" :style="{padding: '0'}" style="color: red" @click="childClick">移除</el-button>
                </el-col>
            </el-row>
            <el-row style="margin: 0;height: auto;color:#717D84;padding-top:5px ">
                <el-col :span="4" >{{sex}}</el-col >
                <el-col class="el-icon-phone-outline" :span="4"></el-col>
                <el-col :span="16">{{phone}}</el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "user",
        data(){
            return {

            }
        },
        props:{
            userName: String,
            sex: String,
            phone: String,
            active:Boolean,
            required: true
        },
        methods: {
            childClick () {
                this.$emit('pullClick')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/components/user.vue